import {parse} from 'query-string';

export function getLocationSearch() {
  //兼容 referralCode,group 参数名大小写不一的情况
  const ignoreCaseParams = ['referralCode', 'group'];
  const query = parse(window.location.search.replace('%26', '&'));
  const keys = Object.keys(query);
  ignoreCaseParams.forEach((name) => {
    const key = keys.find((k) => k.toLowerCase() === name.toLowerCase());
    if (key) {
      const val = query[key];
      delete query[key];
      query[name] = val;
    }
  });
  return query;
}

export function getSearchParamValueIgnoreCase(paramNames) {
  const query = parse(window.location.search.replace('%26', '&'));
  const keys = Object.keys(query);
  return paramNames.reduce((ret, name) => {
    const key = keys.find((k) => k.toLowerCase() === name.toLowerCase());
    ret[name] = query[key];
  }, {});
}
